
import React, { useState, useEffect, useRef } from "react";
import { Box, Slider, } from '@mui/material';
import Cropper from 'react-easy-crop';
import handleImg from './handle.jpg'

const CustomSlider = () => (
    <Box sx={{ display: 'inline-block', background: 'white', borderRadius: 100, p: 1, width: '40px', height: '40px', }}>
        <img src={handleImg} alt="Custom Icon" style={{ width: '100%', height: '100%' }} />
    </Box>
);
const DiffPreview = ({ seperatorWidth = 2, value, value1, backgroundColor = "#343637" }) => {

    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [loading, setLoading] = useState(false);
    const divRef = useRef(null);
    const [width, setWidth] = useState(200); // Initial width of the div
    const [isDragging, setIsDragging] = useState(false);

    const handleMouseDown = () => {
        setIsDragging(true);
    };
    useEffect(() => {
        if (divRef.current) {
            setWidth(divRef.current.offsetWidth / 2);
        }
    }, []); // Run only once after mount

    const handleMouseMove = (e) => {
        if (isDragging) {
            const newWidth = e.clientX; // Adjust based on your layout
            setWidth(newWidth > 50 ? newWidth : 50); // Minimum width of 50px
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    return (<>
        <div style={{
            display: "flex",
            alignItems: "center",
            height: "72vh",
        }}>
            <div
                ref={divRef}
                style={{
                    display: "flex",
                    alignItems: "center",
                    userSelect: "none",
                    height: "100%",
                    width: "100%",
                    position: 'relative'
                }}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
            >
                <div
                    style={{
                        width: `100vw`,
                        height: "100%",
                        backgroundColor: `${backgroundColor}`,
                        position: 'absolute',
                        margin: 'auto',
                        zIndex: 97
                    }}>
                    <div className="crop-container">
                        <Cropper
                            crop={crop}
                            image={value1 || value}
                            zoom={zoom}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            cropShape="rectangle"
                            onMediaLoaded={() => setLoading(false)}
                            maxZoom={8}
                            objectFit="horizontal-cover"
                        />
                    </div>
                </div>
                <div
                    style={{
                        width: `${width}px`,
                        height: "100%",
                        backgroundColor: `${backgroundColor}`,
                        position: 'relative',
                        overflow: 'hidden',
                        zIndex: 98
                        // 'clipPath': `inset(10px 20px 30px 40px)`
                    }}
                >
                    <div
                        className="crop-container"
                        style={{
                            width: `100vw`,
                            height: "100%",
                            backgroundColor: `${backgroundColor}`,
                            position: 'relative',
                        }}>
                        <Cropper
                            crop={crop}
                            image={value}
                            zoom={zoom}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            cropShape="rectangle"
                            onMediaLoaded={() => setLoading(false)}
                            maxZoom={8}
                            objectFit="horizontal-cover"
                        />
                    </div>
                </div>
                <div
                    style={{
                        width: `0`,
                        height: "100%",
                        backgroundColor: `${backgroundColor}`,
                        cursor: "ew-resize",
                        position: 'relative',
                        border: `${seperatorWidth}px solid white`,
                        zIndex: 99
                    }}
                    onMouseDown={handleMouseDown}
                >
                    <div style={{
                        textAlign: 'center',
                        width: "50px",
                        height: "40px",
                        cursor: "ew-resize",
                        position: 'absolute',
                        margin: 'auto',
                        left: -25,
                        right: 0,
                        bottom: 0,
                        top: 0,
                        zIndex: 98,
                        display: 'inline-block'

                    }}>
                        <CustomSlider />
                    </div>
                    <div style={{
                        width: "50px",
                        height: "40px",
                        cursor: "ew-resize",
                        position: 'absolute',
                        margin: 'auto',
                        left: -24,
                        right: 0,
                        bottom: 0,
                        top: 0,
                        zIndex: 99,
                        display: 'inline-block'

                    }}>
                    </div>
                </div>
            </div>
        </div>
        <Box sx={{ width: 200, mx: 'auto', textAlign: 'center', py: 0.5 }}>
            <Slider
                value={zoom}
                onChange={(_, newValue) => setZoom(newValue)}
                step={0.1}
                min={2}
                max={8}
                aria-labelledby="zoom-slider"
                sx={{ color: '#ffd80c' }}
            />
        </Box>
    </>
    );
};

export default DiffPreview;


